import { RouteConfig } from 'vue-router';

export function profileDetailsRoute(name: string): RouteConfig {
  return {
    path: '',
    name,
    component: () => import(/* webpackChunkName: "ProfileDetails" */ '@/views/mainRoute/profile/Details.vue'),
    meta: {
      title: 'Profil'
    }
  };
}
